import { render, staticRenderFns } from "./HeadsupDisplay.vue?vue&type=template&id=aa2d3820&scoped=true&"
import script from "./HeadsupDisplay.vue?vue&type=script&lang=js&"
export * from "./HeadsupDisplay.vue?vue&type=script&lang=js&"
import style0 from "./HeadsupDisplay.vue?vue&type=style&index=0&id=aa2d3820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2d3820",
  null
  
)

export default component.exports